import { Injectable } from '@angular/core';

import { IncidentConstantsService } from '../services/incident-constants-service';
import { DataService } from '../../shared/services/data.service';
import { BaseService } from './../../shared/services/base.service';
import { ConstantsService } from './../../shared/services/constants.service';


@Injectable()
export class IncidentService {
  public updatedActionData: any;

  public updatedIncidentData: any;
  currentIncidentRequestId: string;
  constructor(private dataService: DataService,
    private baseService: BaseService) { }
  public observationRequestId = 0;
  public setAllIncidentIds(allIncidentData) {
    this.baseService.setItemInSession('incidentIds', JSON.stringify(allIncidentData));
  }
  public getAllIncidentIds() {
    return JSON.parse(this.baseService.getItemFromSession('incidentIds'));
  }
  public setupdatedIncidentData(data) {
    this.updatedIncidentData = data;
  }
  public getupdatedIncidentData() {
    return this.updatedIncidentData;
  }

  /**
     * Function to post detalis
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  /**
* Function to Get Observation type Details by company id.
* @param model - Model contain api request
* @param response - response of request.
*/
  getIncidentTypeByCompanyId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentTypeByCompanyId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getIncidentCategoryByCompanyId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentCategoryByCompanyId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getIncidentDataByIncidentId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentDataByIncidentId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  updateIncident(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.UpdateIncidentData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  public setUpdatedData(data, actionType) {
    switch (actionType) {
      
      case 'UpdateAction':
        this.updatedActionData = data;
        break;

    }
  }
  public getUpdatedData(actionType) {
    switch (actionType) {
      
      
      case 'UpdateAction':
        return this.updatedActionData;
    }
  }

  getIncidentColorClass(severity, pear) {
    if (severity && pear) {
      switch (severity) {
        case '1':
        case 1:
          switch (pear) {
            case 'People':
              return 'Slight health effect/injury';
            case 'Environment':
              return 'Slight effect';
            case 'Assets':
              return 'Slight damage US $50K';
            case 'Reputation':
              return 'No concerns';
            case 'NPT':
                return '> 2 & < 6';
          }
          break;

        case '2':
        case 2:
          switch (pear) {
            case 'People':
              return 'Minor health effect/injury';
            case 'Environment':
              return 'Minor effect';
            case 'Assets':
              return 'Minor damage < US $500K';
            case 'Reputation':
              return 'Individual concerns';
            case 'NPT':
                return '> 6 & < 12';
          }
          break;

        case '3':
        case 3:
          switch (pear) {
            case 'People':
              return 'Major health effect/injury including LTI';
            case 'Environment':
              return 'Moderate effect';
            case 'Assets':
              return 'Localised damage < US $2M';
            case 'Reputation':
              return 'Local community attention';
            case 'NPT':
                return '> 12 & < 24';
          }
          break;

        case '4':
        case 4:
          switch (pear) {
            case 'People':
              return 'PTD or 1 fatality';
            case 'Environment':
              return 'Major effect';
            case 'Assets':
              return 'Major damage < US $20M';
            case 'Reputation':
              return 'National attention';
            case 'NPT':
                return '> 24 & < 48';
          }
          break;

        case '5':
        case 5:
          switch (pear) {
            case 'People':
              return 'Multiple fatalities';
            case 'Environment':
              return 'Massive effect';
            case 'Assets':
              return 'Extensive damage < US $20M';
            case 'Reputation':
              return 'International attention';
              case 'NPT':
                return '> 48';
          }
          break;
      }
    } else {
      return '';
    }
  }

  /**
       * Function to Get Incident Request by User Id
       * @param Model - Model to send data to api
       * @param callbackMethod - return the response
       */
  getIncidentRequestByUserId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentRequestByUserId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  raiseIncident(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.RaiseIncident, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
    * Function to Get Incident Request by incident request Id
    * @param Model - Model to send data to api
    * @param callbackMethod - return the response
    */
  getIncidentRequestByIncidentRequestId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentRequestByIncidentRequestId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
  * Function to close  request by incident request id
  * @param Model - Model to send data to api
  * @param callbackMethod - return the response
  */
  closeRequestByIncidentRequestId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.CloseRequestByIncidentRequestId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
   * Function to get route name based on role(case owner)
   * @param routesFlag - array of route
   * @param route - return the route
   */
  checkRouteForCaseOwner(routesFlag: any) {
    const loggedInUserJson = JSON.parse(this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser));
    if (loggedInUserJson.UserRoles.length >= 0) {
      const roles = loggedInUserJson.UserRoles.find((item) => item.RoleName === ConstantsService.Roles.CaseOwner);
      if (roles !== undefined && roles.RoleName === ConstantsService.Roles.CaseOwner) {
        return routesFlag;
      } else {
        // Write logic to remove the route of case owner
        for (let index = 0; index < routesFlag.length; index++) {
          if (routesFlag[index].routeName === IncidentConstantsService.RouteName.CaseOwnerdashboard) {
            routesFlag.splice(index, 1);
          }
        }
        return routesFlag;
      }
    }
  }
  /**
    * Function to Download PDF
    * @param model - Model contain ProcessId and SourceId
    * @param callbackMethod - return the response
    */
  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(IncidentConstantsService.IncidentURL.DownloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
    * Function to Save PDF to DMS
    * @param model - Model contain ProcessId and SourceId
    * @param callbackMethod - return the response
    */
  savePDF(model, callbackMethod) {
    this.dataService.postHttpResponse(IncidentConstantsService.IncidentURL.SavePDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveActions(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.SaveActions, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  saveCaseOwnerAction(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.SaveCaseOwnerAction, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getActionsByIncidentId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetActionByIncidentId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getCaseOwnerSubmittedDetails(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetCaseOwnerSubmittedDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getExportToExcelIncidentRequestByUserId(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetExportToExcelIncidentRequestByUserId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  public setcurrentIncidentRequestId(incId) {
    this.currentIncidentRequestId = incId;
  }
  public getcurrentIncidentRequestId() {
    return this.currentIncidentRequestId;
  }
  getIncidentColor(severity, likelihood) {
    switch (severity) {
      case '0':
      case 0:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
          case 'D':
          case 'E':
            return 'incidentColorBlue';
        }
        break;
      case '1':
      case 1:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
          case 'D':
          case 'E':
            return 'incidentColorBlue';
        }
        break;

      case '2':
      case 2:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
            return 'incidentColorBlue';
          case 'D':
          case 'E':
            return 'incidentColorYellow';
        }
        break;
      case '3':
      case 3:
        switch (likelihood) {
          case 'A':
          case 'B':
            return 'incidentColorBlue';
          case 'C':
          case 'D':
          case 'E':
            return 'incidentColorYellow';
        }
        break;

      case '4':
      case 4:
        switch (likelihood) {
          case 'A':
            return 'incidentColorBlue';
          case 'B':
          case 'C':
            return 'incidentColorYellow';
          case 'D':
          case 'E':
            return 'incidentColorRed';
        }
        break;

      case '5':
      case 5:
        switch (likelihood) {
          case 'A':
          case 'B':
            return 'incidentColorYellow';
          case 'C':
          case 'D':
          case 'E':
            return 'incidentColorRed';
        }
        break;
    }
  }
  getIncidentProcessDetails(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentProcessDetails, model)
      .subscribe(response => {
        callbackMethod(response.Result);
      });
  }
  getInvestigationDetails(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetInvestigationDetails, model)
      .subscribe(response => {
        callbackMethod(response.Result);
      });
  }
  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(IncidentConstantsService.IncidentURL.DownloadZIP, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  closeIncidentWithRating(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.Saveorupdateincidentrating, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getIncidentRatings(model, callbackMethod) {
    this.dataService.post(IncidentConstantsService.IncidentURL.GetIncidentRatings, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
